module.exports = __webpack_public_path__ + "img/bank_history.0e0dabd6.svg";